<template>
  <div id="cus">
    <center>
      <h1>客户管理</h1>
    </center>
    <div style="margin-right: -380px">
        <el-input
          v-model="searchCus"
          placeholder="可通过 客户名称 客户编号搜索"
          style="width:300px;margin-left:18px;margin-top:7px"
          class="filter-item"
        />
        <el-button v-model="searchCus" @click="searchData">搜索</el-button>
    </div>

    <el-table style="width: 100%;"
              :data="cusList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
    >
      <el-table-column type="index" width="50">
      </el-table-column>
      <el-table-column label="客户名称" prop="cusName" width="180">
      </el-table-column>
      <el-table-column label="客户编号" prop="cusId" width="180">
      </el-table-column>
<!-- 定制报表 <router-link :to="{name:'reportList',params:{cusName:cus.name,cusId:cus.id}}"-->
<!--      <a href="reportList?id=cusId?name=cusName">定制报表</a>-->
      <el-table-column label="操作" prop="custom" width="180">
        <template slot-scope="scope">
          <input type="button" value="定制报表" @click="toReportList(scope.row.cusName,scope.row.cusId)" />
        </template>
      </el-table-column>
      <el-table-column  prop="serve" width="200">
        <template slot-scope="scope">
          <input type="button" value="查看服务" @click="tonewreportList(scope.row.cusName,scope.row.cusId)" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  data () {
    return {
      currentPage:1, //初始页
      pagesize:10,    //    每页的数据
      total:0, //总条数　　　　　　　
      cusList: [],
      search:'',
      searchCus:'',
    }
  },
  mounted() {//挂载函数,挂载后执行

    this.getDataFromApi()
  }
  ,
  methods: {//定义方法

    indexMethod(index) {
      return index * 1;
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getDataFromApi();
      console.log(this.pagesize)  //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
     this.getDataFromApi();
      console.log(this.currentPage)  //点击第几页
    },
    // 搜索函数
    searchData(searchCus) {
    this.cusName = searchCus
      this.getDataFromApi();
      console.log(searchCus)
    },
    //跳转reportList页面
    toReportList(cusName,cusId){
      this.$router.push({
        name: 'reportList',
        params: {
          cusName: cusName,
          cusId:cusId
        }
      })
      // alert(cusName)
    },
    //跳转newreportList页面
    tonewreportList(cusName,cusId){
      this.$router.push({
        name: 'newReportList',
        params: {
          cusName: cusName,
          cusId:cusId
        }
      })
      // alert(cusName)
    },
    getDataFromApi() {
      this.$http.get("/dbManage/sys-dataset-detail/queryPageCusList",{
        params:{
          current:this.currentPage,//后台:前台
          size:this.pagesize,//后台:前台
          cusId:this.searchCus,
          cusName:this.searchCus,
        }
      }).then(resp =>{
          resp.data.reduce;
          this.cusList=resp.data.cusList
          console.log(resp.data)
          console.log(resp.data.cusList)
        for (let i=0;i<resp.data.cusList.length;i++){
          this.cusId=resp.data.cusList[i].cusId
          this.cusName=resp.data.cusList[i].cusName
        }
        this.currentPage = resp.data.current;
        this.pagesize = resp.data.size;
        this.total = resp.data.total;
        console.log( this.total)
        }

      )
    },






  }
}

</script>

<style scoped>
#cus{
  position:absolute;
  top:40%;
  left:50%;
  margin:-230px 0 0 -460px;
}
a {
  text-decoration: none;
  color: #393939;
}
</style>



// WEBPACK FOOTER //
// src/components/reportTools/cusMain.vue